import { Component, OnInit, Inject } from '@angular/core';
import { HttpService } from '../../http.service';
import { SnackbarService } from '../../snackbar.service';
import { ValidationService } from '../../validation.service';
import { Messages} from '../../constants/messages';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RolesComponent } from '../../userEntityModals/roles/roles.component';
import { StorageService } from 'src/app/storage.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export interface User {
  user_name: string;
  email_id: string;
  mobile: string;
  carriers: Array<string>;
  roles: Array<string>;
  functions: Array<string>;
}

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  entities: any;
  roles: any;
  selectedRoles: any = [];
  unitSelection: any;
  showButtons = false;
  selectedUsersArray: any = [];
  newUserData: User = {
    user_name: '',
    email_id: '',
    mobile: '',
    carriers: [],
    roles: [],
    functions: []
  };
  preSelectedRoles = [];
  preSelectedFunctions = [];
  editUser = false;
  showLoader = false;
  showRoles = false;
  dataToSend: any = {};
  messages = new Messages();

  constructor(private dialog: MatDialog, private dialog_r: MatDialogRef<AddUserComponent>, private snackbar: SnackbarService, private valid: ValidationService, private http: HttpService,
              private storage: StorageService, private route: Router, private translation: TranslateService, @Inject (MAT_DIALOG_DATA) private parentData: any) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.getRoles();
    this.getEntities();
    if (this.parentData && this.parentData.edit) {
      this.editUser = this.parentData.edit;
      this.newUserData.user_name = this.parentData.data.name;
      this.newUserData.email_id = this.parentData.data.email;
      this.newUserData.mobile = this.parentData.data.mobile;
      this.unitSelection = this.parentData.data.units.map(item => item.name);
      this.preSelectedRoles = this.parentData.data.roles;
      this.newUserData.roles = this.parentData.data.roles ? this.parentData.data.roles.map(item => item._id) : [];
      this.newUserData.functions = this.parentData.data.functions ? this.parentData.data.functions.map(item => item._id) : [];
      this.preSelectedFunctions = this.parentData.data.functions ? this.parentData.data.functions : [];
    }
  }

  getEntities() {
    this.http.get('carrier/entity/all').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const result = data.data;
          this.entities = result;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  getRoles() {
    this.http.get('constants/auth?type=ROLE').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.roles = data.data;
          this.roles.forEach(ele => {
            ele.auth_children.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        } else {
          this.snackbar.openSnackBar(this.messages.USER_DETAILS.ERROR.RULES, '', 'err');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getRolesFromChild(roles: any = {}) {
    this.showRoles = false;
    this.selectedRoles = roles;
    this.newUserData.roles = [];
    this.newUserData.functions = [];
    this.selectedRoles.forEach(element => {
            if (element.checked == true) {
              this.newUserData.roles.push(element._id);
            } else {
              if (element.functionalities && element.functionalities.length) {
                element.functionalities.forEach(item => {
                  if (item.checked == true) {
                    this.newUserData.functions.push(item._id);
                  }
                });
              }
            }
          });
  }
  openRolesModal() {
    const data = this.selectedRoles.length ? this.selectedRoles : this.roles;
    this.dataToSend = {
      selectedRoles: this.selectedRoles.length ? this.selectedRoles : this.roles,
      preSelectedRoles: this.preSelectedRoles,
      preSelectedFunctions: this.preSelectedFunctions,
      edit: this.parentData.edit ? this.parentData.edit : false
    };
    this.showRoles = !this.showRoles;
  }

  selectUnit(unit, event) {
    if (event.source._selected && this.newUserData.carriers.indexOf(unit._id) == -1) {
      this.newUserData.carriers.push(unit._id);
    } else if (this.newUserData.carriers.indexOf(unit._id) != -1) {
      this.newUserData.carriers.splice(this.newUserData.carriers.indexOf(unit._id), 1);
    }
  }


  validate() {
    if (!this.valid.isEmpty(this.newUserData.user_name) && this.newUserData.carriers.length && !this.valid.isEmpty(this.newUserData.mobile) && !this.valid.isEmpty(this.newUserData.email_id)) {
      if (!this.newUserData.roles.length && !this.newUserData.functions.length) {
        this.snackbar.openSnackBar(this.messages.USER_DETAILS.VALIDATION.SELECT_ROLE, '', 'err');
        return false;
      } else if (!this.valid.isMobile(this.newUserData.mobile)) {
        this.snackbar.openSnackBar(this.messages.USER_DETAILS.ERROR.MOBILE_NUMBER, '', 'err');
        return false;
      } else if (!this.valid.isEmail(this.newUserData.email_id)) {
        this.snackbar.openSnackBar(this.messages.USER_DETAILS.ERROR.EMAIL, '', 'err');
        return false;
      } else {
        return true;
      }
    } else {
      console.log(this.newUserData);

      this.snackbar.openSnackBar(this.messages.USER_DETAILS.VALIDATION.FILL_ALL, '', 'err');
    }
  }

  submit() {
    const valid = this.validate();
    if (valid) {
      this.showLoader = true;

      if (!this.parentData.edit) {
        this.http.post('carrier_user/add', this.newUserData).subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              this.showLoader = false;

              this.snackbar.openSnackBar(this.messages.USER_DETAILS.SUCCESS.USER_ADD, '');
              this.newUserData = {
                user_name: '',
                email_id: '',
                mobile: '',
                carriers: [],
                roles: [],
                functions: []
              };
              delete this.selectedRoles;
              this.unitSelection = [];
              this.closeDialog(data);
            }
          },
          (err: any) => {
            this.showLoader = false;

            this.snackbar.openSnackBar(err.error.message, '', 'err');
            if (err.error.statusCode === 401) {
              this.valid.logout();
            }
          }
        );
      }
      if (this.parentData && this.parentData.edit) {
          this.http.put('carrier_user/' + this.parentData.data._id, this.newUserData).subscribe(
            (data: any) => {
              if (data.statusCode === 200) {
                this.showLoader = false;

                this.snackbar.openSnackBar(this.messages.USER_DETAILS.SUCCESS.editUser, '');
                this.newUserData = {
                  user_name: '',
                  email_id: '',
                  mobile: '',
                  carriers: [],
                  roles: [],
                  functions: []
                };
                delete this.selectedRoles;
                this.unitSelection = [];
                this.closeDialog(data);
              }
            },
            (err: any) => {
              this.showLoader = false;
              this.snackbar.openSnackBar(err.error.message, '', 'err');
              if (err.error.statusCode == 401) {
                this.valid.logout();
              }
            }
          );
        }

    }
  }

  closeDialog(data) {
    this.dialog_r.close(data);
  }

}
